/* global axios */
import ApiClient from '../ApiClient';

class CaptainCustomTools extends ApiClient {
  constructor() {
    super('captain/custom_tools', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, {
      custom_tool: data,
    });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, {
      custom_tool: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  createFromTemplate(templateId, configurableValues = {}) {
    return axios.post(this.url, {
      custom_tool: {
        template_id: templateId,
        configurable_values: configurableValues,
      },
    });
  }
}

export default new CaptainCustomTools();
